export class HomePageDisplay {
    constructor(
        public displayType: string,
        public displayArg?: any
    ) { }
}
